export default __webpack_public_path__ + "static/media/oliver_m.b28a82c1.jpg";